import { z } from 'zod';

export const CoreNotifySubscriberContactMethodHistoryCategoryTypeSchema = z.enum(['OptIn','OptOut','Invite','Verify','Create','SubscriptionGroupPreferenceUpdate']);

export type CoreNotifySubscriberContactMethodHistoryCategoryTypeType = `${z.infer<typeof CoreNotifySubscriberContactMethodHistoryCategoryTypeSchema>}`

export default CoreNotifySubscriberContactMethodHistoryCategoryTypeSchema;
